export const environment = {

authentication: {
    // true  = Microsoft Entra login
    // false = existing RetailHub username/password login
    useAzureAd: true
  },

  msal: {
    // RetailHub-Web
    clientId: 'f8aa798a-2bcb-4d0c-a59f-da4cc8663e3e',

    // tenantId: '354ffbfb-e376-41b5-9059-522f3cdf73be',
    tenantId: 'organizations',

    // redirect: 'http://localhost:4200/callback',
    redirect: 'https://retailhubweb.azurewebsites.net',

    // RetailHub-API
    apiScope:
      'api://0f694339-ffff-4778-b7f4-829ba72569bd/user_impersonation'
  },
  graph: {
      uri: 'https://graph.microsoft.com/v1.0/me',
      scopes: ['User.Read']
  },
  graph1: {
      uri: 'https://graph.microsoft.com/v1.0/users/*',
      scopes: ['User.Read']
  },
  graph2: {
      uri: 'https://graph.microsoft.com/v1.0/groups',
      scopes: ['Group.Read.All']
  },
  env: "PROD",
  version: "1.1.0",
  gateway_url: "https://retailhubapi-gateway.azurewebsites.net",
  sectors: [
      {
          sector_name: "Innovisor",
          region_view: "single",  
          groups: [
              { name: "NA-PHC", key: "f9646414-8e80-4048-9717-06f7b45e114a",regionName:"NA" }
          ]
      }
  ]
};